export default __webpack_public_path__ + "static/media/Home_school.b8245f7d.jpg";